export const SET_SELECTED_FILTERS = 'SET_SELECTED_FILTERS';
export const DESELECT_FILTERS = 'DESELECT_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';
